import { storeRequestHeader } from "@go-novus/admin-api";

/** 后台与店面共用协议；店铺头只送同源 Playground BFF，不送 Shopify 或 Socket。 */
export function widgetBusinessFetch(
  handshakeUrl: string,
  fetchImpl: typeof fetch = fetch,
): typeof fetch {
  if (typeof window === "undefined") return fetchImpl;
  const entry = new URL(handshakeUrl, window.location.href);
  const shop = entry.searchParams.get("shop");
  if (
    entry.origin !== window.location.origin ||
    !entry.pathname.startsWith("/api/playground/") ||
    !shop
  )
    return fetchImpl;
  return (input, init) => {
    const target = new URL(
      input instanceof Request ? input.url : String(input),
      window.location.href,
    );
    if (
      target.origin !== entry.origin ||
      !target.pathname.startsWith("/api/playground/")
    )
      return fetchImpl(input, init);
    const headers = new Headers(init?.headers);
    headers.set(storeRequestHeader, shop);
    return fetchImpl(input, { ...init, headers });
  };
}
